import { connect } from 'react-redux'

import { selectCurrentCommittedTicketSearchQueryCurrentPart } from 'selectors/search/base'
import { selectTicketSearchSuggestions } from 'selectors/search_suggestions'

import ConversationListHeader from 'components/ConversationList/Header'
import TitleBar from './TitleBar'
import Search from './Search'
import FilterBar from './FilterBar'

const select = state => {
  return {
    currentPart: selectCurrentCommittedTicketSearchQueryCurrentPart(state),
    suggestions: selectTicketSearchSuggestions(state),
    SearchComponent: Search,
    TitleBarComponent: TitleBar,
    FilterBarComponent: FilterBar,
  }
}
export default connect(select)(ConversationListHeader)
